import WISDropdown, { IWISDropdown } from '@jana-technology/lht-wis-dropdown'

/**
 * WISDropdown component with optimal style for toolbar tab display
 * @param props IWISDropdown
 * @returns WISDropdown component styled for toolbar tab display
 */
const WISDropdownTab = (props: IWISDropdown) => (
  <div className='mx-2 font-medium' style={{ lineHeight: 'normal' }}>
    <WISDropdown {...props} />
  </div>
)

export default WISDropdownTab
